import { reimRequest } from '@services'
import { Notify } from 'vant'
import { deepCopy } from '@utils/basicUtil'
export default {
  namespace: 'my-examine',
  state: {
    tableData: [],
    reimInfo: {
      invoiceInfos: []
    },
    examineInfo: {},
    total: 0
  },
  actions: {
    async delReimById ({ commit }, reimNos) {
      const res = await reimRequest.reim.delReimById({ reimNos })
      if (res.success) {
        Notify({ type: 'success', message: '删除成功' })
      } else {
        Notify({ type: 'danger', message: res.message })
        return true
      }
    },
    async getExamineInfo ({ commit }, { reimNo, id }) {
      const reimInfo = await reimRequest.reim.getReimInfo({ reimNo })
      let examineInfo = {}
      if (!id) {
        examineInfo = await reimRequest.reim.getExamineInfo({ bizDataCode: reimNo, bizType: 'REIMBURES' })
      } else {
        examineInfo = await reimRequest.reim.getExamineInfo({ id, bizType: 'REIMBURES' })
      }
      if (reimInfo.success) {
        await commit('setReimInfo', reimInfo.result || {})
      } else {
        if (reimInfo.message) Notify({ type: 'danger', message: reimInfo.message })
      }
      if (examineInfo.success) {
        let info = deepCopy(examineInfo.result)
        if (info && info.nodeList) {
          info.nodeList.forEach(item => {
            if (item.nodeType !== 'SYSTEM') {
              item.approvalRoleId = JSON.parse(item.approvalRoleId)
              item.approverId = JSON.parse(item.approverId)
            }
          })
        }
        await commit('setExamineInfo', info || {})
      } else {
        if (examineInfo.message) Notify({ type: 'danger', message: examineInfo.message })
      }
    },
    /**
     * @description 查询
     * @param commit
     * @param query
     * @return {Promise<void>}
     */
    async getTableData ({ commit }, query) {
      console.log(query)
      await commit('setTableData', [])
      const res = await reimRequest.reim.getExaminePage(query)
      if (res.success) {
        let tableData = deepCopy(res.result.records)
        tableData = tableData.map(i => ({ ...i, ...i.instanceBizDate }))
        await commit('setTableData', tableData || [])
        await commit('setTotal', res.result.total)
      } else {
        if (res.message) Notify({ type: 'danger', message: res.message })
      }
    },
    /**
     * @description 二次查询拼接逻辑
     * @param commit
     * @param state
     * @param query
     * @return {Promise<void>}
     */
    async getTableDataConcat ({ commit, state }, query) {
      let oldTableData = state.tableData
      const res = await reimRequest.reim.getExaminePage(query)
      if (res.success) {
        let tableData = deepCopy(res.result.records)
        tableData = tableData.map(i => ({ ...i, ...i.instanceBizDate }))
        await commit('setTableData', oldTableData.concat(tableData))
        await commit('setTotal', res.result.total)
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    },
    async examine ({ commit }, select) {
      const res = await reimRequest.reim.examine(select)
      if (res.success) {
        Notify({ type: 'success', message: '操作成功' })
      } else {
        Notify({ type: 'danger', message: res.message })
      }
    }
  },
  mutations: {
    setReimInfo (state, reimInfo) {
      state.reimInfo = reimInfo
    },
    setExamineInfo (state, examineInfo) {
      state.examineInfo = examineInfo
    },
    setTableData (state, tableData) {
      state.tableData = tableData
    },
    setTotal (state, total) {
      state.total = total
    }
  }
}
